import { createFeatureActionNamer } from '../../../../../redux/action-name';

const getActionName = createFeatureActionNamer('ra-death-dependants');

export const ADD_DEPENDANT = getActionName('ADD_DEPENDANT');
export const DELETE_DEPENDANT = getActionName('DELETE_DEPENDANT');
export const UPDATE_DEPENDANT = getActionName('UPDATE_DEPENDANT');
